import React from 'react';
import { Row } from 'react-bootstrap';
import { FormFilterCard, FormCol } from 'motion-components';
import * as Yup from 'yup';
import { SelectMonth } from '../../components/select-month';
import { SelectYear } from '../../components/select-year';
import { useTranslation } from 'react-i18next';
import { FieldSelectCollector, FieldSelectMaterial } from 'shared-pages/components';
import { SelectRoute } from '../../components/select-route';
import { splitGmtFromDate } from 'motion-components';
import { useRootStore } from 'store';

/* ----------- Filters ------------------ */
export const Filters = ({ onChange, initialValues }) => {
  const { appStore } = useRootStore();
  const { t } = useTranslation();
  function handleFiltersSubmit(values, { setSubmitting }) {
    setTimeout(() => {
      setSubmitting(false);
      const startDate = new Date(values.year, 0, 1);
      const endDate = new Date(values.year, 11, 31, 23, 59, 59);
      const materialId = values.materialId;
      const routeTypeId = values.routeTypeId;
      onChange({
        startDate: splitGmtFromDate(startDate),
        endDate: splitGmtFromDate(endDate),
        materialId,
        routeTypeId,
        collectorId: values.collectorId,
      });
    }, 400);
  }

  const filters = {
    //month: initialValues?.month ?? undefined,
    year: initialValues?.year ?? new Date().getFullYear(),
    materialId: initialValues?.materialId ?? undefined,
    routeTypeId: initialValues?.routeTypeId ?? undefined,
    collectorId: initialValues?.collectorId ?? undefined,
  };

  const formShape = {
    //month: Yup.string(),
    year: Yup.string().required('Το Έτος είναι υποχρεωτικό'),
    materialId: Yup.number().required('Το Απόβλητο είναι υποχρεωτικό'),
    routeTypeId: Yup.number().required('Ο Τύπος Δρομολογίου είναι υποχρεωτικός'),
    collectorId: Yup.number().nullable(),
  };

  const validationSchema = Yup.object().shape(formShape);
  return (
    <FormFilterCard
      title={t('Κριτήρια Αναζήτησης')}
      onSubmit={handleFiltersSubmit}
      initialValues={filters}
      validationSchema={validationSchema}
    >
      <Row>
        <SelectYear name="year" title="Έτος" required={true} as={FormCol} />
        {/* <SelectMonth name="month" title="Μήνας" required={true} as={FormCol} /> */}
        <FieldSelectMaterial as={FormCol} />
        <SelectRoute name="routeTypeId" title="Τύπος Δρομολογίου" required={true} as={FormCol} />
        {appStore.isPlatformOwner && (
          <FieldSelectCollector as={FormCol} name="collectorId" label={t('Συλλέκτης')} />
        )}
      </Row>
    </FormFilterCard>
  );
};
